__turbopack_context__.v({
  "button": "button-module-scss-module__MsGhRG__button",
  "default": "button-module-scss-module__MsGhRG__default",
  "default-2": "button-module-scss-module__MsGhRG__default-2",
  "default-icon": "button-module-scss-module__MsGhRG__default-icon",
  "default-icon-danger": "button-module-scss-module__MsGhRG__default-icon-danger",
  "loading": "button-module-scss-module__MsGhRG__loading",
  "outlined": "button-module-scss-module__MsGhRG__outlined",
  "primary": "button-module-scss-module__MsGhRG__primary",
  "secondary": "button-module-scss-module__MsGhRG__secondary",
  "simple": "button-module-scss-module__MsGhRG__simple",
});
